import React from "react";
import MaintenanceScreen from "@screens/MaintenanceScreen";

const ErrorBoundaryFallback = () => {
  return (
    <MaintenanceScreen />
    // <div role="alert">
    //   <p>Something went wrong:</p>
    //
    //   <pre style={{ color: "red" }}>{error.message}</pre>
    //
    //   <Link to="/" onClick={resetErrorBoundary}>
    //     홈으로
    //   </Link>
    // </div>
  );
};

export default ErrorBoundaryFallback;
